import { render, staticRenderFns } from "./SharePoints.vue?vue&type=template&id=425fbab1&scoped=true&"
import script from "./SharePoints.vue?vue&type=script&scoped=true&lang=js&"
export * from "./SharePoints.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./SharePoints.vue?vue&type=style&index=0&id=425fbab1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425fbab1",
  null
  
)

export default component.exports